import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import VPNService from './components/VPNService';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <About />
      <VPNService />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
}
